export const PAYMENT_GATEWAYS = {
  razorpay: 'RAZORPAY',
  billdesk: 'BILLDESK',
};

export const RAZORPAY_OPTIONS = {
  image:
    'https://assets1.cleartax-cdn.com/clearsave-frontend/images/1558516436_pinchy.png',
  theme: {
    color: '#00A0FF',
  },
};

export const RAZORPAY_CHECKOUT_JS =
  'https://checkout.razorpay.com/v1/checkout.js';

export const PAYMENT_STATUS = {
  successful: 'SUCCESSFUL',
  pending: 'PENDING',
  failed: 'FAILED',
};



// WEBPACK FOOTER //
// ./constants/payments.ts